module.exports = __webpack_public_path__ + "static/media/icon1.36299542.svg";